<template>
    <footer class="footer-component">
        <div class="container">
            <div class="footer-content">
                <div class="footer-left">
                    <h3>AM 26. OKTOBER SYLVIA BRAUN WÄHLEN <span class="weitermachen">#weitermachen</span> </h3>
                    <p class="footer-contact">Kontakt: <a href="mailto:Gut4Brk@sylvia-braun.de" class="footer-email">Gut4Brk@sylvia-braun.de</a></p>
                    <p class="footer-legal">
                        <router-link to="/datenschutz" class="footer-link">Datenschutz</router-link> | 
                        <router-link to="/impressum" class="footer-link">Impressum</router-link>
                    </p>
                </div>
                <div class="footer-right">
                    <h3 class="footer-support">UNTERSTÜTZT VON:</h3>
                    <div class="footer-logos">
                        <img src="/images/fdp.svg" alt="FDP" class="party-logo">
                        <img src="/images/spd.jpeg" alt="SPD" class="party-logo spd-logo">
                        <img src="/images/gruene.svg" alt="Grüne" class="party-logo">
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
export default {
    name: 'FooterComponent'
}
</script>